import React from "react";
import ReferralView from "./View";

const Referral = () => {
  return <ReferralView />;
};

export default Referral;
